module.exports = __webpack_public_path__ + "img/浙江大学LOGO.cb93aa6a.png";